import type { AppRouteRecordRaw } from 'common/router/type'
import { getDeviceType } from 'common/utils/system'
// import { useTimer } from '@/hooks/useTimer'
import { useTimer } from '@/hooks/customTimer'

import useOrderStore from '@/store/order'
import { ref } from 'vue'
import { Order } from '@/types/order'
import { getOrderInfo } from '@/api/order'


export const route: AppRouteRecordRaw = {
  path: `/PTMPAY`,
  component: () =>
    getDeviceType() === 'mobile' ? import('./mobile.vue') : import('./pc.vue')
}

export const usePageHook = () => {
  // const orderStore = useOrderStore()
  // const { orderInfo, startLoopTimer } = useTimer()

  // 保存原始 favicon 和标题
  let originalFavicon: HTMLLinkElement | null = null
  let originalTitle = ''

  // 修改浏览器标题和图标
  const setFaviconAndTitle = (imgUrl: string, title: string) => {
    // 仅在第一次调用时保存原始状态
    if (!originalTitle) {
      originalTitle = document.title
      originalFavicon = document.querySelector('link[rel="icon"]')
    }

    // 更改标题
    document.title = title

    // 更改 favicon
    let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement
    if (!favicon) {
      favicon = document.createElement('link')
      favicon.rel = 'icon'
      document.head.appendChild(favicon)
    }
    favicon.href = imgUrl
  }

  // 还原浏览器标题和图标
  const restoreFaviconAndTitle = () => {
    if (originalTitle) {
      document.title = originalTitle
    }

    // 移除当前 favicon 并恢复原始 favicon
    const currentFavicon = document.querySelector('link[rel="icon"]')
    if (currentFavicon) {
      document.head.removeChild(currentFavicon)
    }

    if (originalFavicon) {
      document.head.appendChild(originalFavicon)
    }
  }

  // 监听页面卸载事件
  const handleBeforeUnload = () => {
    restoreFaviconAndTitle()
  }

  // 添加事件监听器
  window.addEventListener('beforeunload', handleBeforeUnload)

  // 在组件销毁前也需要清理
  const cleanup = () => {
    window.removeEventListener('beforeunload', handleBeforeUnload)
  }

  const orderInfo = ref({} as Order)
  const timer = ref(0)
  /** 打开轮询 */
  const openPoll = () => {
    timer.value = setInterval(() => {
      getOrderInfos()
    }, 5000)
  }
  const getOrderInfos = () => {
    getOrderInfo().then(res => {
      orderInfo.value = res
      if (orderInfo.value.product_code === 'QRPH') {
        setFaviconAndTitle('https://test-asiashop.oss-cn-hongkong.aliyuncs.com/static/media/PHP/Gcash.png', 'Gcash')
      } else {
        cleanup()
      }
      // openPoll()
    })
  }
  const init = () => {
    getOrderInfos()
  }

  return {
    orderInfo,
    init,
    cleanup,
  }
}
